import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {getToken} from '@/utils/auth'

NProgress.configure({showSpinner: false})

const whiteList = ['/login', '/activeAccount', '/register', '/home/newHome',
    '/home/homePage', '/home/technologyCenter', '/home/serviceSupport',
    '/home/dataBaseQuery', '/home/classicCase', '/home/dataContent', '/home/contact',
    '/home/exampleData', '/userAgreement', '/PGSPage', '/home/tutorial',
    '/tutorial/Introduction', '/tutorial/LoginSRT-Server', '/tutorial/TenModules',
    '/exampleData/quickStart', '/exampleData/caseStudy', '/exampleData/caseStudyMerfish',
    '/exampleData/mouseBrain', '/tutorial/Miscellanea']

router.beforeEach((to, from, next) => {
    NProgress.start();
    if (getToken()) {
        if (to.path === '/login') {
            next('/myProject/allProject');
            NProgress.done()
        } else {
            // if (store.getters.user == null) {
            //   // 判断当前用户是否已拉取完user_info信息


            // } else {
            //   next()
            // }
            store.dispatch('GetInfo').then(() => {
                next()
                // next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
            }).catch(() => {
            })
        }
    } else {
        // 没有token
        if (whiteList.indexOf(to.path) !== -1) {
            // 在免登录白名单，直接进入
            next()
        } else {
            next('/login') // 否则全部重定向到登录页
            NProgress.done()
        }
    }
})
router.afterEach(() => {
    NProgress.done()
})
